import { MapPin, Music, Mic, ArrowLeftRight, UtensilsCrossed } from "lucide-react";
import { AGENDA, LUNCH_SPONSORS } from "../data/conferenceData";

const TYPE_STYLES = {
  general: { bg: "var(--type-general-bg)", color: "var(--primary)", icon: Music },
  keynote: { bg: "var(--type-keynote-bg)", color: "var(--maroon)", icon: Mic },
  rotation: { bg: "var(--type-rotation-bg)", color: "var(--maroon)", icon: ArrowLeftRight },
  break: { bg: "var(--type-break-bg)", color: "var(--primary-dark)", icon: UtensilsCrossed },
};

export default function Agenda() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="agenda-page">
      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "13px",
          marginBottom: "16px",
          textAlign: "center",
        }}
      >
        Full-day schedule for June 8, 2026
      </p>

      {AGENDA.map((item, idx) => {
        const style = TYPE_STYLES[item.type] || TYPE_STYLES.general;
        const Icon = style.icon;
        const isLast = idx === AGENDA.length - 1;
        return (
          <div
            key={item.id}
            className="flex items-stretch"
            data-testid={`agenda-item-${idx}`}
          >
            {/* Timeline column */}
            <div
              className="flex flex-col items-center"
              style={{ width: "28px", paddingTop: "18px" }}
            >
              <div
                style={{
                  width: "14px",
                  height: "14px",
                  borderRadius: "7px",
                  borderWidth: "3px",
                  borderStyle: "solid",
                  borderColor: "var(--background)",
                  backgroundColor: style.color,
                }}
              />
              {!isLast && (
                <div
                  className="flex-1"
                  style={{
                    width: "2px",
                    backgroundColor: "var(--border)",
                    marginTop: "4px",
                  }}
                />
              )}
            </div>

            {/* Card with colored left border */}
            <div
              className="flex-1 shadow-card"
              style={{
                backgroundColor: "var(--surface)",
                borderRadius: "14px",
                padding: "14px",
                borderLeftWidth: "4px",
                borderLeftStyle: "solid",
                borderLeftColor: style.color,
                marginBottom: "14px",
                marginLeft: "0px",
              }}
            >
              {/* Time pill with icon */}
              <div
                className="inline-flex items-center self-start"
                style={{
                  backgroundColor: style.bg,
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  borderRadius: "999px",
                  gap: "6px",
                  marginBottom: "8px",
                }}
              >
                <Icon size={14} color={style.color} strokeWidth={2} />
                <span
                  style={{
                    fontWeight: 800,
                    fontSize: "11px",
                    letterSpacing: "0.5px",
                    color: style.color,
                  }}
                >
                  {item.time}
                </span>
              </div>

              <p
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  color: "var(--primary-dark)",
                  marginBottom: "4px",
                  lineHeight: "21px",
                }}
              >
                {item.title}
              </p>

              {item.description && (
                <p
                  style={{
                    fontSize: "13px",
                    color: "var(--text-muted)",
                    lineHeight: "19px",
                    marginBottom: "6px",
                    whiteSpace: "pre-line",
                  }}
                >
                  {item.description}
                </p>
              )}

              {item.location && (
                <div
                  className="flex items-center"
                  style={{ gap: "4px", marginTop: "4px" }}
                >
                  <MapPin size={14} color="var(--text-muted)" />
                  <span
                    style={{
                      color: "var(--text-muted)",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}
                  >
                    {item.location}
                  </span>
                </div>
              )}

              {item.id === "lunch" && (
                <div
                  className="flex items-center flex-wrap"
                  style={{
                    marginTop: "10px",
                    paddingTop: "10px",
                    borderTop: "1px solid var(--border)",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "10px",
                      fontWeight: 800,
                      letterSpacing: "1.5px",
                      color: "var(--gold)",
                    }}
                  >
                    SPONSORED BY
                  </span>
                  {LUNCH_SPONSORS.map((s) => (
                    <div
                      key={s.name}
                      className="flex items-center"
                      style={{
                        height: "24px",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                        backgroundColor: "white",
                        border: "1px solid var(--border)",
                        borderRadius: "6px",
                      }}
                    >
                      <img
                        src={s.logo}
                        alt={s.name}
                        style={{ maxHeight: "14px", objectFit: "contain" }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
